import { useEffect, useMemo } from 'react';
import { useAnalysisData } from '../../contexts/AnalysisDataContext';
import { AnalysisRange } from './useAnalysisRange';
import { Granularity } from '../../utils/analytics/types';
import {
  avgCancellationLeadDays,
  cancellationLeadBuckets,
  cancellationRateSeries,
  cancellationReasons,
  isCancelledStay,
  overallCancellationRate,
  resoldCancelledNights,
} from '../../utils/analytics/cancellationMetrics';

export function useCancellationAnalysis(range: AnalysisRange, granularity: Granularity) {
  const { stays, loading, error, ensureRange } = useAnalysisData();

  useEffect(() => {
    ensureRange(range.from, range.to);
  }, [range.from, range.to, ensureRange]);

  return useMemo(() => {
    const { from, to } = range;
    const cancelledCount = stays
      .filter(isCancelledStay)
      .filter(s => s.checkIn >= from && s.checkIn <= to).length;

    return {
      loading,
      error,
      rate: overallCancellationRate(stays, from, to),
      cancelledCount,
      series: cancellationRateSeries(stays, from, to, granularity),
      leadBuckets: cancellationLeadBuckets(stays, from, to),
      avgLeadDays: avgCancellationLeadDays(stays, from, to),
      reasons: cancellationReasons(stays, from, to),
      resold: resoldCancelledNights(stays, from, to),
    };
  }, [stays, range, granularity, loading, error]);
}
